export default "__VITE_ASSET__BReMRnjg__"